import * as React from "react";
import { formatDateTime } from "../../CommonFunctions";

interface IProps {
    product: string;
    productWording: JSX.Element;
    endDate: string;
}

export class RenewalDeclinedBanner extends React.Component<IProps> {
    constructor(props: any) {
        super(props);
    }

    public render(): JSX.Element {
        return (
            <div className="banner pending-renewal-banner banner-warn">
                <div className="banner-text">
                    <p>
                        Heads up - your {this.props.product} policy for {this.props.productWording} <strong>ends on {formatDateTime(this.props.endDate)}.</strong>{' '}
                        Until then you are still covered.
                    </p>
                    <p className="font-weight-bold">Make sure you arrange alternative cover for your {this.props.product}.</p>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/banners/RenewalDeclinedBanner.tsx